
<template>
<div class="suggestion-block">
  <div class="wrap">
    <div class="image-holder">
      <img :src="`${cdn}/images/img59.png`" alt="airport-lounge">
    </div>
    <div class="description">
      <h3>{{ shortenName(product.product_name, airport.airport_name) }}</h3>
      <span class="text hotel-room"><i class="icon-bus"></i>{{ $t('airportlounge.results.terminal') }} {{ product.terminal }}</span>
      <ul class="list list-unstyled">
        <li v-for="(item, key) in product.description" :key="key">
            <i class="icon-check_circle"></i> {{ item }}
        </li>
      </ul>
    </div>
  </div>
  <ul class="btns-list list-unstyled">
    <li>
      <span @click="moreInfo = product" class="btn btn-secondary text-uppercase">
        {{ $t('airportparking.results.product.more_info') }} <i class="icon-add"></i>
      </span>
    </li>
    <li><a @click="bookNow" class="btn btn-primary">{{ $t('airportlounge.results.add_to') }}</a></li>
  </ul>
</div>
</template>

<script>
import { sync, get } from 'vuex-pathify';
import { eventBus } from "@/eventBus";
import mixins from '@/mixins';

export default {
  name: "item-upgrade-lounge",
  mixins: [mixins.validate, mixins.globals, mixins.format],
  props: {
    product: { type: Object, default: () => {}, required: true },
  },
  computed: {
    airport: get("results/airport"),
    moreInfo: sync("modals/moreInfo"),
    quote: sync("quote")
  },
  methods: {
    bookNow() {
      eventBus.$emit("SELECTED", this.product);
    }
  }
};
</script>